export default () => {
    'use strict';

    const url = location.href.replace(/\/$/, "");
    const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');

    // Open tab util function
    const openTab = (tabButton:HTMLElement) => {
        if (tabButton && !tabButton.classList.contains('accordion-button')) {
            if(!tabButton.classList.contains('active')){
                const tab = window.bootstrap.Tab.getOrCreateInstance(tabButton);
                tab?.show();
            }
            tabButton.focus();
        }
    }

    // Open tab depending on url hash
    if (location.hash) {
        const tabButton = document.querySelector(`[data-bs-target="${location.hash}"]`) as HTMLElement;
        if(tabButton) openTab(tabButton);
    }

    // Open tab on specific anchor call-to-action
    const tabsCta = document.querySelectorAll(`[href*="tab"]`)
    tabsCta.forEach(cta => {
        cta.addEventListener('click', () => {
            const tabButton = document.querySelector(`[data-bs-target="${cta.getAttribute('href')}"]`) as HTMLElement;
            if (tabButton) openTab(tabButton);
        })
    })

    // Add current tab to url hash
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const anchor = tab.getAttribute('data-bs-target');
            history.replaceState(null, '', url.split('#')[0] + anchor);
        })
    })
}
